import { render, staticRenderFns } from "./FreightTablesFilters.vue?vue&type=template&id=6dd87c46&scoped=true"
import script from "./FreightTablesFilters.vue?vue&type=script&lang=js"
export * from "./FreightTablesFilters.vue?vue&type=script&lang=js"
import style0 from "./FreightTablesFilters.vue?vue&type=style&index=0&id=6dd87c46&prod&scoped=true&lang=less"
import style1 from "./FreightTablesFilters.vue?vue&type=style&index=1&id=6dd87c46&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd87c46",
  null
  
)

export default component.exports